import { Button } from '@athena/forge';

interface ForgotUsernameLinkProps {
  onClick: () => void;
}

export default function ForgotUsernameLink({ onClick }: ForgotUsernameLinkProps) {
  return (
    <Button
      text="Forgot username?"
      variant="tertiary"
      size="small"
      onClick={onClick}
    />
  );
}

